<mat-card appearance="outlined" class="your-plan-container">
  <div [class.is-backoffice]="isBackofficePage">
    @if (!isBackofficePage && !isSelfServiceCustomer) {
      <div class="your-plan-details-text" style="float: right">
        <button mat-stroked-button class="primary-button" (click)="openUpgradePopup()">{{ "generic.upgrade" | translate }}</button>
      </div>
    }
    <div class="your-plan-row title">{{ "subscription.new-usage.usage" | translate }}</div>
    <div class="accounts-info-container">
      <div class="your-plan-row accounts-info">
        @if (hasSeveralAccounts) {
          <div
            class="your-plan-row accounts-info"
            [innerHTML]="'subscription.new-usage.multiple-accounts-usage' | translate: { resetDayInMonth: calculteResetDate() }"></div>
        }
        @if (!hasSeveralAccounts) {
          <div
            class="your-plan-row accounts-info"
            [innerHTML]="'subscription.new-usage.reset-in-x-month' | translate: { resetDayInMonth: calculteResetDate() }"></div>
        }
      </div>
    </div>
    @if (isSelfServiceCustomer && trafficProgress && trafficProgress >= 100) {
      <div class="your-plan-over-limit-row" (click)="openUpgradeAccountFlyout()">
        <mat-icon>stop_circle</mat-icon>
        <div class="over-limit-text">
          @if (trafficProgress - 100 <= 25 && customer.tier === Tier.Pro) {
            <span>{{ "subscription.new-usage.over-limit-bar-pro-tier" | translate }}</span>
          } @else {
            <span>{{ "subscription.new-usage.over-limit-bar" | translate }}</span>
            @if (subscriptionDaysRemaining > 0) {
              <span>:&nbsp;{{ subscriptionRecurringDate }}</span>
            }
          }
        </div>
      </div>
    }
    <div class="your-plan-row row-content usage-row">
      <div class="your-plan-details-text-section usage-section">
        <ng-container>
          <div class="usage-details-row usage-text-line with-slider">
            <div class="label-text">
              <span>{{ "subscription.new-usage.title-events" | translate }}</span>
              <mat-icon class="explainer" (click)="explainerDialogService.setContentExpainer(EXPLAINER_TEXTS.pageviews)">help_outline</mat-icon>
            </div>
            <div class="spacer"></div>
            <div class="limitation-main-value">
              <span>{{ limitationsWithUsage?.events?.value | thousandSuffix: 1 }}</span>
              <span>&nbsp;/&nbsp;</span>
              <span>{{ limitationsWithUsage?.events?.max | thousandSuffix: 1 }}</span>
            </div>
          </div>
          <app-determinate-progress-bar
            class="your-plan-progress-bar"
            [colorizeProgress]="true"
            [value]="limitationsWithUsage?.events?.value"
            [height]="10"
            [maxValue]="limitationsWithUsage?.events?.max"
            [showValue]="false"></app-determinate-progress-bar>
        </ng-container>
        <ng-container>
          <div class="usage-details-row usage-text-line" [class.with-slider]="!isSurveyResponsesUnlimited">
            <div class="label-text">
              <span>{{ "subscription.new-usage.title-survey-responses" | translate }}</span>
              <mat-icon class="explainer" (click)="explainerDialogService.setContentExpainer(EXPLAINER_TEXTS.surveyResponses)">help_outline</mat-icon>
            </div>
            <div class="spacer"></div>
            @if (!isSurveyResponsesUnlimited) {
              <div class="limitation-main-value">
                <span>{{ limitationsWithUsage?.surveyResponses?.value | thousandSuffix: 1 }}</span>
                <span>&nbsp;/&nbsp;</span>
                <span>{{ totalSurveyResponses | thousandSuffix: 1 }}</span>
              </div>
            }
            @if (isSurveyResponsesUnlimited) {
              <div class="limitation-main-value">
                <span>{{ "subscription.new-usage.unlimited" | translate }}</span>
              </div>
            }
          </div>
          @if (!isSurveyResponsesUnlimited) {
            <app-determinate-progress-bar
              class="your-plan-progress-bar"
              [colorizeProgress]="true"
              [value]="limitationsWithUsage?.surveyResponses?.value"
              [height]="10"
              [maxValue]="totalSurveyResponses"
              [showValue]="false"></app-determinate-progress-bar>
          }
        </ng-container>
        <div class="usage-details-row usage-text-line">
          <div class="label-text">
            <span>{{ "subscription.new-usage.title-batch-records" | translate }}</span>
            <mat-icon class="explainer" (click)="explainerDialogService.setContentExpainer(EXPLAINER_TEXTS.rows)">help_outline</mat-icon>
          </div>
          <div class="spacer"></div>
          <div class="limitation-main-value">
            <span>{{ limitationsWithUsage?.batchRecords?.value | thousandSuffix: 1 }}</span>
            <span>&nbsp;/&nbsp;</span>
            <span>{{ limitationsWithUsage?.batchRecordsPerMonth?.value | thousandSuffix: 1 }}</span>
          </div>
        </div>
        <ng-container>
          <app-determinate-progress-bar
            class="your-plan-progress-bar"
            [colorizeProgress]="true"
            [value]="limitationsWithUsage?.batchRecords?.value"
            [height]="10"
            [maxValue]="limitationsWithUsage?.batchRecordsPerMonth?.value"
            [showValue]="false"></app-determinate-progress-bar>
        </ng-container>
        @if (hasEmailTemplates) {
          <div class="usage-details-row usage-text-line with-slider">
            <div class="label-text">
              <span>{{ "subscription.new-usage.title-transactional-emails" | translate }}</span>
              <mat-icon class="explainer" (click)="explainerDialogService.setContentExpainer(EXPLAINER_TEXTS.transactionalEmails)">help_outline</mat-icon>
            </div>
            <div class="spacer"></div>
            <div class="limitation-main-value">
              <span>{{ emailsCount | thousandSuffix: 1 }}</span>
              <span>&nbsp;/&nbsp;</span>
              <span>{{ emailsLimit | thousandSuffix: 1 }}</span>
            </div>
          </div>
          <app-determinate-progress-bar
            class="your-plan-progress-bar"
            [colorizeProgress]="true"
            [value]="emailsCount"
            [height]="10"
            [maxValue]="emailsLimit"
            [showValue]="false"></app-determinate-progress-bar>
        }
        @if (isPublicApiActive) {
          <div class="usage-details-row usage-text-line" [class.with-slider]="!isPublicApiCallsUnlimited">
            <div class="label-text">
              <span>{{ "subscription.new-usage.title-public-api-calls" | translate }}</span>
              <mat-icon class="explainer" (click)="explainerDialogService.setContentExpainer(EXPLAINER_TEXTS.publicApiCalls)">help_outline</mat-icon>
            </div>
            <div class="spacer"></div>
            @if (!isPublicApiCallsUnlimited) {
              <div class="limitation-main-value">
                <span>{{ publicApiCallsCount | thousandSuffix: 1 }}</span>
                <span>&nbsp;/&nbsp;</span>
                <span>{{ publicApiCallsLimit | thousandSuffix: 1 }}</span>
              </div>
            } @else {
              <div class="limitation-main-value">
                <span>{{ "subscription.new-usage.unlimited" | translate }}</span>
              </div>
            }
          </div>
          @if (!isPublicApiCallsUnlimited) {
            <app-determinate-progress-bar
              class="your-plan-progress-bar"
              [colorizeProgress]="true"
              [value]="publicApiCallsCount"
              [height]="10"
              [maxValue]="publicApiCallsLimit"
              [showValue]="false"></app-determinate-progress-bar>
          }
        }
        @if (aiUsage) {
          <div class="usage-details-row usage-text-line with-slider">
            <div class="label-text">
              <span>{{ "subscription.new-usage.title-ai-usage" | translate }}</span>
              <mat-icon class="explainer" (click)="explainerDialogService.setContentExpainer(EXPLAINER_TEXTS.aiUsage)">help_outline</mat-icon>
            </div>
            <div class="spacer"></div>
            <div class="limitation-main-value">
              <span>{{ "subscription.new-usage.ai-usage-percent" | translate: { percent: aiUsage.percentUsed } }}</span>
            </div>
          </div>
          <app-determinate-progress-bar
            class="your-plan-progress-bar"
            [colorizeProgress]="true"
            [value]="aiUsage.percentUsed"
            [height]="10"
            [maxValue]="100"
            [showValue]="false"></app-determinate-progress-bar>
        }
        <div class="usage-details-row usage-text-line">
          <div class="label-text">
            <span>{{ "subscription.new-usage.title-automations" | translate }}</span>
            <mat-icon class="explainer" (click)="explainerDialogService.setContentExpainer(EXPLAINER_TEXTS.automations)">help_outline</mat-icon>
          </div>
          <div class="spacer"></div>
          <div>{{ limitationsWithUsage?.automations?.value | thousandSuffix: 1 }}</div>
        </div>
        <div class="usage-details-row usage-text-line">
          <div class="label-text">
            <span>{{ "subscription.new-usage.title-users" | translate }}</span>
            <mat-icon class="explainer" (click)="explainerDialogService.setContentExpainer(EXPLAINER_TEXTS.users)">help_outline</mat-icon>
          </div>
          <div class="spacer"></div>
          <div>{{ limitationsWithUsage?.users?.value }}</div>
        </div>
        <div class="usage-details-row usage-text-line">
          <div class="label-text">
            <span>{{ "subscription.new-usage.title-contacts" | translate }}</span>
            <mat-icon class="explainer" (click)="explainerDialogService.setContentExpainer(EXPLAINER_TEXTS.profiles)">help_outline</mat-icon>
          </div>
          <div class="spacer"></div>
          <div>{{ limitationsWithUsage?.persons?.value | thousandSuffix: 1 }}</div>
        </div>
      </div>
      @if (isSelfServiceCustomer) {
        <div
          class="your-plan-details-text-section usage-message-section"
          [class.close-to-limit]="trafficProgress !== undefined && trafficProgress >= 80 && trafficProgress < 100"
          [class.over-limit]="(trafficProgress !== undefined && trafficProgress >= 100) || (isSelfServiceTrial && trialExpirationDays < 0)">
          @if (!isSelfServiceTrial || trialExpirationDays >= 0) {
            @if (trafficProgress !== undefined && trafficProgress < 80) {
              <div
                class="message-content info"
                [innerHTML]="
                  'subscription.new-usage.traffic-left' | translate: { trafficLeft: trafficLeft | thousandSuffix: 1, resetDays: daysUntilReset }
                "></div>
            }
            @if (trafficProgress !== undefined && trafficProgress >= 80 && trafficProgress < 100) {
              <div class="message-title">{{ "subscription.new-usage.close-to-limit-sessions-title" | translate }}</div>
              <div class="message-content">{{ "subscription.new-usage.close-to-limit-sessions-text" | translate }}</div>
              <button mat-flat-button class="text-button message-action" (click)="openUpgradeAccountFlyout()">
                {{ "subscription.new-usage.close-to-limit-sessions-action" | translate }}
              </button>
            }
            @if (trafficProgress !== undefined && trafficProgress >= 100) {
              <div class="message-title">{{ "subscription.new-usage.over-limit-sessions-title" | translate }}</div>
              <div class="message-content">{{ "subscription.new-usage.over-limit-sessions-text" | translate }}</div>
              <button mat-flat-button class="text-button message-action" (click)="openUpgradeAccountFlyout()">
                {{ "subscription.new-usage.close-to-limit-sessions-action" | translate }}
              </button>
            }
          }
          @if (isSelfServiceTrial && trialExpirationDays < 0) {
            <div class="message-title">{{ "subscription.new-usage.over-limit-sessions-title" | translate }}</div>
            <div class="message-content">{{ "subscription.new-usage.trial-expired-text" | translate }}</div>
            @if (!isCustomPlan) {
              <div>
                <button mat-flat-button class="text-button message-action" (click)="openUpgradeAccountFlyout()">
                  {{ "subscription.new-usage.close-to-limit-sessions-action" | translate }}
                </button>
              </div>
            }
            @if (isCustomPlan) {
              <div>
                <div class="message-content">{{ "subscription.new-usage.note-custom-plan" | translate }}</div>
              </div>
            }
          }
        </div>
      }
    </div>
  </div>
</mat-card>
